module.exports = "/assets/e01e95f14b1491d84cb69a3d32474ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PR.png
// module id = 2850
// module chunks = 0